import React from "react";
import { Grid, TextField, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import useTotals from "../hooks/useTotals";
import { useLocation } from "react-router-dom";
import Sites from "../helpers/sitesLinks";
import { removeDuplicates } from "../helpers/functions";

const styles = {
  total: {
    fontFamily: "Montserrat, sans-serif",
    fontOpticalSizing: "auto",
    fontWeight: 600,
    fontStyle: "normal",
    letterSpacing: "2.34px",
    lineHeight: "19px",
    fontSize: "20px"
  },

}

function renderTextField(label, value, otherValue = "") {
  const discount = otherValue !== "" ? `/ %${otherValue}` : ""
  return (
    <Grid item xs={12} key={label}>
      <TextField
        label={label}
        size="small"
        variant="standard"
        style={{ width: "100%" }}
        value={`$${(Number(value) || 0).toLocaleString()} ${discount}`}
        InputProps={{ readOnly: true }}
      />
    </Grid>
  );
}



function renderTextFieldCatalogo(label, value) {
  return (
    <Grid item xs={12} key={label} display="flex" justifyContent="space-between" sx={{ position: 'fixed', bottom: 70, width: '30%', zIndex: 1, backgroundColor: '#fff', padding: '15px 10px', boxShadow: '0 -2px 5px rgba(0,0,0,0.1)' }}>
      <Typography variant="h5" gutterBottom>
        Totales
      </Typography>
      <Typography sx={{ ...styles.total, }}>
        {`$${(Number(value) || 0).toLocaleString()}`}
      </Typography>
    </Grid>
  );
}

export default function OrderTotals({ dynamicsId, totalDesc, item, order }) {
  const { items, webOrderId } = useSelector((state) => order ? state.order : state.cart)
  const { subtotal, discount, tax, total, descuentoComercial } = useTotals(removeDuplicates(items), dynamicsId, totalDesc);
  const location = useLocation();
  const matchRouteWithParams = (path, route) => {
    if (route !== "/catalogo-details/:productId") {
      return path === route
    }
    const regex = new RegExp(route.replace(":productId", "[^/]+"));
    return regex.test(path);
  };


  const site = Sites.urls.some(route => matchRouteWithParams(location.pathname, route))
    ? "/catalogo"
    : "/products";


  let fieldsTotals;
  if (item && webOrderId !== null) {
    const { subtotal, discount, tax, total } = item;
    site === "/catalogo" ? fieldsTotals = [renderTextFieldCatalogo("Subtotal", subtotal)] :
      fieldsTotals = [
        renderTextField("Subtotal", subtotal),
        renderTextField("Descuento Comercial", discount),
        renderTextField("Impuestos", tax),
        renderTextField("Total", total),
      ];

  } else {
    site === "/catalogo" ? fieldsTotals = [renderTextFieldCatalogo("Subtotal", subtotal)] :
      fieldsTotals = [
        renderTextField("Subtotal", subtotal),
        renderTextField("Descuento Comercial", discount, descuentoComercial),
        renderTextField("Impuestos", tax),
        renderTextField("Total", total),
      ];

  }


  return (
    <Grid container spacing={2}>
      {fieldsTotals}
    </Grid>
  );
}
